var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['container-logo', _vm.wrapperClass]},[_c('NuxtLink',{attrs:{"to":_vm.localizedUrl}},[_c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],staticClass:"logo-img",attrs:{"id":"logoCollecting","data-src":_vm.isFixedNav
          ? _vm.logoNavPopUp
          : _vm.isHeaderMobile
          ? _vm.logoNavPopUp
          : _vm.logoHeaderPc,"alt":"Logo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }